<form *ngIf="entityId"
      [formGroup]="frm"
      (submit)="onSubmit()"
      class="row">
    <div class="col-md-6 col-12 ps-4 pt-2">
        <h3>
            {{'RETURNS.SHARE_WITH' | translate}}</h3>
        <div class="form-group">

            <label class="control-label">
                {{'RETURNS.USER_EMAIL' | translate}}
            </label>
            <input class="form-control"
                   formControlName="UserEmail" />
        </div>
        <div class=" btnSendStatus">
            <button class="btn btnModal"
                    type="submit">
                {{'RETURNS.ADD' | translate}}
            </button>

        </div>
    </div>
    <div class="col-md-6 col-12 ps-4 pt-2"
         *ngIf="users?.length > 0">
        <h3>
            {{'RETURNS.SHARED_WITH' | translate}}
        </h3>
        <ul class="list-group"
            style="margin-top: 30px;">
            <li class="list-group-item "
                *ngFor="let user of users">
                {{user}}
                <button type="button"
                        class="removeShare bi bi-x"
                        (click)="clickDelete(user)">
                </button>
            </li>
        </ul>
    </div>
</form>